import React from 'react';

const About = (props) => {
  return (
    <div>
      <h1>About</h1>
      <p>This is a simple example of a React application with a Spline scene.</p>
    </div>
  );
}

export default About;